<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'ArgToutSavoirFinancementsDispo'
});
</script>
<template>
  <ka-container
    code="arg-tout-savoir-financements-dispo"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-text code="tout-savoir-sur-les">
      <span v-html="t('argToutSavoirFinancementsDispo.toutSavoirSurLes.value', `Tout savoir sur les financements dispo pour mon entreprise`)" />
    </ka-text>
    <ka-text code="credit-dimpot-budgets">
      <span v-html="t('argToutSavoirFinancementsDispo.creditDimpotBudgets.value', `Crédit d'impôt, budgets formation, prime exceptionnelle, opportunité à durée limitée, pour ne pas manquer l'info abonnez-vous à notre newsletter 👇`)" />
    </ka-text>
    <ka-button
      code="mabonner"
      :options="{
        ripple: true,
        href: `https://share.hsforms.com/1b5abc90QQtKrGWlmbOKLAQ2xvix`,
        ariaLabel: `button`,
        click: componentInstance.mabonnerClick
      }">
      <span v-html="t('argToutSavoirFinancementsDispo.mabonner.value', `M'abonner`)" />
    </ka-button>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { argToutSavoirFinancementsDispoComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c21')
const component = argToutSavoirFinancementsDispoComponent()
const componentInstance = component.newStoreInstance()
withDefaults(defineProps<{
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

syncComponentStore(componentInstance)
</script>
